/* Tony & Charlie - Betaallijst op productpagina */
document.addEventListener("DOMContentLoaded", function () {
  var source = document.querySelector("footer [data-tc-payments]"),
    form = document.getElementById("TC-ProductForm");
  if (source && form) {
    var copy = source.cloneNode(true);
    copy.removeAttribute("data-tc-payments");
    form.parentNode.insertBefore(copy, form.nextSibling);
  }
});

/* Tony & Charlie - Voortgangsbalk: 10% korting vanaf 2 items én €75 */
document.addEventListener("DOMContentLoaded", function () {
  var MIN_ITEMS = 2,
    DISCOUNT_EUR = 75,
    DISCOUNT_LABEL = "10% off";

  var style = document.createElement("style");
  style.textContent = `
    .cart-ship.tc-tiered { text-align: center; padding: 14px 20px 10px; }
    .cart-ship .tc-msg { display: block; font-size: 13.5px; font-weight: 600; color: #2B231F; line-height: 1.4; }
    .cart-ship .tc-sub { display: block; font-size: 12px; color: #786E66; margin-top: 3px; }
    .cart-ship .cart-ship-bar { width: 100%; height: 6px; background: #ECE7DD; border-radius: 99px; margin-top: 9px; overflow: hidden; }
    .cart-ship .cart-ship-bar span { display: block; height: 100%; background: #2E7D32; border-radius: 99px; transition: width 0.35s ease; }
    .tc-discount-row { display: flex; justify-content: space-between; gap: 12px; font-size: 13px; color: #2E7D32; margin: 4px 0 6px; font-weight: 600; }
    .tc-was { text-decoration: line-through; opacity: 0.55; font-weight: 400; margin-right: 8px; font-size: 0.9em; }
    .tc-saving { display: block; text-align: right; font-size: 12px; color: #2E7D32; margin: -2px 0 6px; }
  `;
  document.head.appendChild(style);

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString("nl-NL", {
        style: "currency",
        currency: currency || "EUR"
      });
    } catch (e) {
      return (cents / 100).toFixed(2) + " " + (currency || "EUR");
    }
  }

  function rate() {
    try {
      return parseFloat(window.Shopify.currency.rate) || 1;
    } catch (e) {
      return 1;
    }
  }

  function discountTitle(cart) {
    var a = (cart.cart_level_discount_applications || [])[0];
    if (a && a.title) return a.title;
    for (var items = cart.items || [], i = 0; i < items.length; i++) {
      var al = (items[i].line_level_discount_allocations || [])[0];
      if (al && al.discount_application && al.discount_application.title) {
        return al.discount_application.title;
      }
    }
    return "Discount";
  }

  var ship = document.querySelector("[data-cart-ship]");
  var writing = false;

  function renderBar(cart) {
    if (!ship || !cart || !cart.item_count) {
      if (ship) ship.setAttribute("hidden", "");
      return;
    }

    var r = rate();
    var discAt = Math.round(DISCOUNT_EUR * 100 * r);
    var before = cart.original_total_price || cart.total_price;
    var itemCount = cart.item_count || 0;
    var html = "";
    var pct = 0;

    var hasMinItems = itemCount >= MIN_ITEMS;
    var hasMinAmount = before >= discAt;

    if (hasMinItems && hasMinAmount) {
      // Beide voorwaarden gehaald
      pct = 100;
      var savingsText = cart.total_discount > 0 
        ? `You save ${money(cart.total_discount, cart.currency)} on this order`
        : "Your discount will be applied at checkout";
      html = `
        <span class="tc-msg">Congrats! You've unlocked <strong>${DISCOUNT_LABEL}</strong></span>
        <span class="tc-sub">${savingsText}</span>
        <div class="cart-ship-bar"><span style="width:100%"></span></div>
      `;
    } else if (itemCount < MIN_ITEMS) {
      // Nog maar 1 product in de cart
      var itemsNeeded = MIN_ITEMS - itemCount;
      var itemWord = itemsNeeded === 1 ? "1 more item" : itemsNeeded + " more items";
      
      if (hasMinAmount) {
        // Wel al boven de €75, maar nog maar 1 product
        pct = 60;
        html = `
          <span class="tc-msg">Free shipping within the EU is included</span>
          <span class="tc-sub">Add <strong>${itemWord}</strong> to unlock ${DISCOUNT_LABEL}</span>
          <div class="cart-ship-bar"><span style="width:60%"></span></div>
        `;
      } else {
        // Nog onder de €75 én nog maar 1 product
        var remainingEur = discAt - before;
        pct = Math.max(10, Math.min(85, Math.round((before / discAt) * 100)));
        html = `
          <span class="tc-msg">Free shipping within the EU is included</span>
          <span class="tc-sub">Add <strong>${itemWord}</strong> & reach ${money(discAt, cart.currency)} to get ${DISCOUNT_LABEL}</span>
          <div class="cart-ship-bar"><span style="width:${pct}%"></span></div>
        `;
      }
    } else {
      // Wel 2 of meer producten, maar totaal is nog onder €75
      var remaining = discAt - before;
      pct = Math.max(0, Math.min(95, Math.round((before / discAt) * 100)));
      html = `
        <span class="tc-msg">Free shipping within the EU is included</span>
        <span class="tc-sub">Add ${money(remaining, cart.currency)} more to unlock <strong>${DISCOUNT_LABEL}</strong></span>
        <div class="cart-ship-bar"><span style="width:${pct}%"></span></div>
      `;
    }

    ship.innerHTML = html;
    ship.classList.add("tc-tiered");
    ship.removeAttribute("hidden");
  }

  function renderDrawerTotals(cart) {
    var sub = document.querySelector("[data-cart-subtotal]");
    if (!sub) return;

    var row = sub.closest(".cart-drawer-subtotal");
    var old = document.querySelector(".cart-drawer-foot .tc-discount-row");
    if (old) old.remove();

    if (cart.total_discount > 0 && cart.original_total_price > cart.total_price) {
      sub.innerHTML = '<span class="tc-was">' + money(cart.original_total_price, cart.currency) + '</span>' + money(cart.total_price, cart.currency);
      if (row) {
        var d = document.createElement("div");
        d.className = "tc-discount-row";
        d.innerHTML = "<span>" + discountTitle(cart) + "</span><span>−" + money(cart.total_discount, cart.currency) + "</span>";
        row.parentNode.insertBefore(d, row);
      }
    } else {
      sub.textContent = money(cart.total_price, cart.currency);
    }
  }

  var pending = null;
  function refresh() {
    if (writing) return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          writing = true;
          renderBar(cart);
          renderDrawerTotals(cart);
          setTimeout(function () { writing = false; }, 0);
        })
        .catch(function () {});
    }, 60);
  }

  if (ship) {
    new MutationObserver(function () {
      if (!writing) refresh();
    }).observe(ship, { childList: true, subtree: false, attributes: true, attributeFilter: ["hidden"] });
  }

  document.addEventListener("tc:cart-changed", refresh);
  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", refresh);
  });
});
